import { api } from "./api";

const get = (url, params) => api.get(url, { params }).then((r) => r.data);

export const fetchNewsMeta = () => get("/news/meta");
export const fetchNewsFeed = (params) => get("/news/feed", params);
export const fetchStories = (params) => get("/news/stories", params);
export const fetchStory = (id) => get(`/news/stories/${id}`);
export const fetchPairs = (hours) => get("/news/pairs", { hours });
export const fetchNewsSources = () => get("/news/sources");
export const fetchFeeds = () => get("/news/feeds");
export const discoverFeeds = (url) => api.post("/news/discover", { url }).then((r) => r.data);
export const fetchAlerts = (params) => get("/news/alerts", params);
export const fetchAnalytics = (hours) => get("/news/analytics", { hours });
export const fetchNewsMap = (hours) => get("/news/map", { hours });
export const refreshNews = () => api.post("/barometer/refresh").then((r) => r.data);

export const MODEL_LABELS = { public: "Public", corporate: "Corporate", nonprofit: "Nonprofit", "member-funded": "Member-funded", independent: "Independent" };
export const KIND_LABELS = { rss: "Articles", video: "YouTube", social: "Social posts" };
export const PERSPECTIVE_COLORS = { Left: "#be123c", "Centre-left": "#f43f5e", Centre: "#64748b", "Centre-right": "#3b82f6", Right: "#1d4ed8" };

export const cleanParams = (p) => Object.fromEntries(Object.entries(p).filter(([, v]) => v !== "" && v !== null && v !== undefined && v !== false));

export const formatDate = (iso) => new Date(iso).toLocaleString("en-CA", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
